<template>
    <div id="Evv_Details">
        <EvvDetailsHomeHealth
            v-if="options.Application == applicationEnum.AgencyCore"
            :visit-details="options"
            :cancel="cancel"
            :ok="ok"
        />
        <EvvDetailsHomeCare
            v-if="options.Application == applicationEnum.HomeCare"
            :visit-details="options"
            :cancel="cancel"
            :ok="ok"
        />
    </div>
</template>

<script src="./EvvDetails.ts"></script>
